import { render } from "./BranchViewer.vue?vue&type=template&id=09f4b78f&scoped=true&ts=true"
import script from "./BranchViewer.vue?vue&type=script&lang=ts"
export * from "./BranchViewer.vue?vue&type=script&lang=ts"

import "./BranchViewer.vue?vue&type=style&index=0&id=09f4b78f&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09f4b78f"]])

export default __exports__